import {getActualMonth, getDayRange, getPastMonth} from '../../../utils/getTimeRange'
import moment from 'moment/moment'


const resultSelect = [
    {name: 'result', label: 'Норма', value: 'Без патологических изменений'},
    {name: 'result', label: 'Вызов', value: 'вызов'}
]
const base = [
    {name: 'place', label: 'Машина', value: 'машина'},
    {name: 'place', label: 'Кабинет', value: 'кабинет'}
]
const status = [
    {name: 'status', label: 'Прошел', value: 'прошел'},
    {name: 'status', label: 'Не прошел', value: 'не прошел'},
    {name: 'status', label: 'Ошибка', value: 'ошибка'}
]
const status1 = [
    {name: 'status1', label: 'Ошибок нет', value: 'ошибок нет'},
    {name: 'status1', label: 'Ошибка', value: 'ошибка'}
]

const periodSelect = [
    {name: 'period', label: 'Сегодня', value: getDayRange(0)},
    {
        name: 'period',
        label: 'Вчера',
        value: [new Date(moment(new Date).add(-1, 'day')), new Date(moment(new Date).add(-1, 'day'))]
    },
    {
        name: 'period',
        label: 'Последние 7 дней',
        value: [new Date(moment(new Date).add(-7, 'days')), new Date()]
    },
    {
        name: 'period',
        label: 'Последние 14 дней',
        value: [new Date(moment(new Date).add(-14, 'days')), new Date()]
    },
    {name: 'period', label: 'Этот месяц', value: getActualMonth()},
    {name: 'period', label: 'Прошлый месяц', value: getPastMonth()},
    {name: 'period', label: 'Все время', value: ''}

]
const doctorStatus = [
    {label: 'Зарегистрирован', value: 'Зарегистрирован'},
    {label: 'Подтвержден', value: 'Подтвержден'},
    {label: 'Не подтвержден', value: 'Не подтвержден'},
    {label: 'Протестирован', value: 'Протестирован'},
    {label: 'Не прошел тест', value: 'Не прошел тест'},
    {label: 'Авторизован', value: 'Авторизован'},
    {label: 'Заблокирован', value: 'Заблокирован'},
]

const testStatus = [
    {label: 'Протестирован', value: 'Протестирован'},
    {label: 'Не прошел тест', value: 'Не прошел тест'}
]
const testType = [
    {label: "Флюорография", value: "Флюорография"},
    {label: "Рентгенология", value: "Рентгенология"},
    {label: "Маммография", value: "Маммография"}
]
const success = [
    {label: "Выполнено", value: "true"},
    {label: "Не выполнено", value: "False"}
]

export const models = (model) => {
    const models = {
        result: resultSelect,
        base,
        period: periodSelect,
        status,
        status1,
        doctorStatus,
        testStatus,
        testType,
        success
    }
    return models[model]
}